export const parseCoastMediaIds = (ids?: string | null) =>
    ids
        ?.trim()
        .split(",")
        .map(v => v.trim()) || [];
